import React from "react";
import { useLocation, useParams } from "react-router-dom";
import "./Banner.css";
const BASEURL = process.env.REACT_APP_SOMPROP_BASE_URL;
const Banner = () => {
  const location = useLocation();
  const paramsList = useParams();
  const getTitle = () => {
    switch (location.pathname) {
      case "/about":
        return "ABOUT US";
      case "/current-properties":
        return "PORTFOLIO";
      case `/current-properties/${paramsList.propertySlug}`:
        return "PORTFOLIO";
      case "/past-properties":
        return "PORTFOLIO";
      case `/past-properties/${paramsList.propertySlug}`:
        return "PORTFOLIO";
      case "/investments":
        return "INVESTMENTS";
      case "/property-services":
        return "PROPERTY SERVICES";
      case "/spi-services":
        return (
          <img
            src={`${BASEURL}/images/SPiServices-logo.png`}
            width="298"
            height="64"
            alt="sp iservice"
          />
        );
      case "/contact":
        return "CONTACT";
      default:
        return "ERROR";
    }
  };

  return (
    <div className="inner-banner">
      <img
        src="/images/inner-banner.jpg"
        width="1400"
        height="230"
        alt="banner"
      />
      <div className="inner-banner-position">
        <h2>{getTitle()}</h2>
      </div>
    </div>
  );
};

export default Banner;
